import { useState, useEffect, useRef } from './basic'

// Timeout happens once, no plan to change fn, nor delay
export const useTimeout = (fn, delay) =>
  useEffect(() => {
    if (delay) {
      const timer = setTimeout(fn, delay)
      return () => clearTimeout(timer)
    }
  }, [])

// having dynamic fn and delay can be useful, but can also be removed if not utilized
export const useInterval = (fn, delay) => {
  const callback = useRef()

  useEffect(() => {
    callback.current = fn
  }, [fn])

  useEffect(() => {
    const tick = () => callback.current()

    if (delay !== null) {
      const timer = setInterval(tick, delay)
      return () => clearInterval(timer)
    }
  }, [delay])
}

export const useTimer = (seconds, onComplete) => {
  const [progress, setProgress] = useState(seconds)

  useInterval(() => {
    setProgress(progress - 1)
    if (progress == 1) onComplete()
  }, 1000)

  return progress
}

export const useLocalStorageCountdown = (key, delay) => {
  const readyAt = +localStorage[key] || 0
  const now = +new Date()
  const [seconds, setSeconds] = useState(Math.max(0, Math.ceil((readyAt - now) / 1000)))

  useInterval(() => {
    seconds && setSeconds(Math.max(0, seconds - 1))
  }, 1000)

  const reset = () => {
    localStorage[key] = now + delay * 1000
    setSeconds(delay)
  }
  const displaySeconds = seconds <= 0 ? '' : ` (${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')})`
  return [seconds <= 0, displaySeconds, reset]
}
